// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a89f4e8e","239":"11302777","455":"75b2e82d"}[chunkId] + ".chunk.js";
};